module.exports = __webpack_public_path__ + "static/media/galdisa_blogImg3.d09f713f.jpg";